import { Doughnut } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'

export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.addPlugin([ChartJsPluginDataLabels])
    this.renderChart(this.chartdata, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/home/homeData/dropdowns/DoughnutChart.js